var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      !_vm.restodirectory()
        ? _c(
            "div",
            [
              _c("LoggedInHeader", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isLoggedIn(),
                    expression: "isLoggedIn()"
                  }
                ]
              }),
              _vm._v(" "),
              _vm.guestUser &&
              !_vm.isLoggedIn() &&
              !_vm.isConfirmationPage() &&
              !_vm.isLinkExpiryPage()
                ? _c("GuestHeader")
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("router-view"),
      _vm._v(" "),
      _vm.guestUser ? _c("div", [_c("AddCardModal")], 1) : _vm._e(),
      _vm._v(" "),
      _vm.getFirstEmployeeId
        ? _c(
            "div",
            [
              _c("AddCardModal"),
              _vm._v(" "),
              _c("OrderDetailModal"),
              _vm._v(" "),
              _c("ReferralModal"),
              _vm._v(" "),
              _c("AdminAddUserModal"),
              _vm._v(" "),
              _c("EditBulkUsersModal"),
              _vm._v(" "),
              _c("AdminEditUserModal"),
              _vm._v(" "),
              _c("PlaceOrderDetailModal"),
              _vm._v(" "),
              _c("AddTeamModal"),
              _vm._v(" "),
              _c("AssignToTeamModal"),
              _vm._v(" "),
              _c("AddAdminModal"),
              _vm._v(" "),
              _c("DefaultOfficeSelectionModal")
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoggedIn() ? _c("Footer") : _vm._e(),
      _vm._v(" "),
      _vm.guestUser && !_vm.isLoggedIn() && !_vm.isLinkExpiryPage()
        ? _c("GuestFooter")
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "layer" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 